import React from "react";
import { ShieldCheck } from "lucide-react";

export default function VerifiedBadge({ size = "sm", className = "" }) {
  const dims = size === "lg" ? { box: 24, icon: 14 } : { box: 18, icon: 11 };
  return (
    <span
      data-testid="verified-badge"
      title="Identity verified"
      className={`inline-flex items-center justify-center rounded-full bg-[#913831] text-white shadow-[0_2px_6px_rgba(145,56,49,0.35)] ${className}`}
      style={{ width: dims.box, height: dims.box }}
    >
      <ShieldCheck size={dims.icon} strokeWidth={2} />
    </span>
  );
}
